import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  initialValue?: string;
  size?: 'md' | 'lg';
  placeholder?: string;
  autoFocus?: boolean;
}

export default function SearchBar({
  initialValue = '',
  size = 'md',
  placeholder = '搜索电影、电视剧、综艺或资讯…',
  autoFocus = false,
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
  };

  const isLarge = size === 'lg';

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex w-full items-center gap-2 rounded-full border border-background-200/80 bg-background-100/80 pl-4 pr-1.5 backdrop-blur ${
        isLarge ? 'h-14' : 'h-11'
      }`}
    >
      <i className="ri-search-line shrink-0 text-base text-foreground-500"></i>
      <input
        type="search"
        name="keyword"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视内容"
        className={`min-w-0 flex-1 bg-transparent text-foreground-900 outline-none placeholder:text-foreground-500 ${
          isLarge ? 'text-base' : 'text-sm'
        }`}
      />
      <button
        type="submit"
        className={`flex shrink-0 cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 ${
          isLarge ? 'h-11 px-5 text-sm' : 'h-8 px-4 text-xs'
        }`}
      >
        <i className="ri-search-line"></i>
        <span className="hidden sm:inline">搜索</span>
      </button>
    </form>
  );
}